<div class="modal-header text-center" style="border-bottom: none">
  <div class="m-auto">
    <h4>Are you sure?</h4>
  <p>
    You are about to delete
    <strong *ngIf="!isForDeleteNote && !isForDeleteDataField">{{
      displayName
    }}</strong>
    <span *ngIf="isForDeleteNote && !isForDeleteDataField"
      >the note <strong>{{ displayName }}</strong></span
    >
    <span *ngIf="!isForDeleteNote && isForDeleteDataField"
      >the field <strong>{{ displayName }}</strong></span
    >.
    <br />
    If you want to proceed, click delete.
  </p>
  </div>
</div>
<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div
    class="btn btn-danger pull-right"
    aria-label="Confirm"
    (click)="confirm()"
  >
    Delete
  </div>
</div>
